import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component, EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewEncapsulation
} from "@angular/core";
import {OperationalContactModel} from "../../models/operational-contact.model";

require('./bringoz-operational-contacts-table.scss');
@Component({
  standalone: false,
  selector: 'app-bringoz-operational-contacts-table',
  templateUrl: './bringoz-operational-contacts-table.html',
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BringozOperationalContactsTableComponent implements OnChanges, AfterViewInit {

  @Input() operationalContacts: OperationalContactModel[];
  @Input() canEdit: boolean;
  @Output() onEdit = new EventEmitter<any>();

  constructor() {

  }

  ngOnChanges(changes: SimpleChanges) {

  }

  ngAfterViewInit(): void {
    // const div1 = document.getElementById('header');
    // const div2 = document.querySelectorAll('.cdk-virtual-scroll-viewport')[0];
    //
    //
    // div2.addEventListener('scroll', e => {
    //   div1.scrollTop = div2.scrollTop;
    //   div1.scrollLeft = div2.scrollLeft;
    // })
  }

}
